import { Kanban } from '../../../_services/kanban/kanban.model'

export class CardMapper {
  static mapCardFields(
    card: Kanban.Card.Entity,
    boardFields: Kanban.Board.Entity['fields']
  ): Kanban.Card.Entity {
    return {
      ...card,
      fields: card.fields.map(field => {
        const fieldLabel = boardFields.find(f => f.id === field.fieldId)
        return { ...field, label: fieldLabel?.label }
      })
    }
  }
}
